import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { DropDownConfigService } from '../../../../formbird-sc-shared/src/lib/drop-down-config.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { DeviceDetectService } from '../../../../formbird-sc-shared/src/lib/device-detect.service';

interface DropDownComponentDefinition extends ComponentDefinition {
  multiSelect?: boolean;
  dropDownList?: string[];
  defaultValue?: any;
  configObjectName?: any;
}

@Component({
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class DropDownComponent extends AbstractComponent<DropDownComponentDefinition> implements OnInit, AfterViewInit {

  isMultiple: boolean;
  defaultValue: any[];
  optionArray: any[] = [];

  public formValueControl: AbstractControl;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cd: ChangeDetectorRef,
    public deviceDetectService: DeviceDetectService,
    private dropDownConfigService: DropDownConfigService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cd);
  }

  async ngOnInit() {

    this.formValueControl = new FormControl();

    super.ngOnInit();

    this.optionArray = this.componentDefinition.dropDownList || [];

    if (this.componentDefinition.configObjectName) {
      try {
        const result = await this.dropDownConfigService.searchConfigList(
          this.componentDefinition.configObjectName,
          this.fieldName,
          this.template.documentId
        );

        if (result && result.length) {
          this.optionArray = result;
        }

        this.cd.detectChanges();
      } catch(err) {
        console.error(err);
      }
    }
  }

  initializeFieldValue() {

    this.isMultiple = this.componentDefinition.multiSelect;

    if ((this.document && this.document[this.fieldName])) {
      this.defaultValue = this.document[this.fieldName];
      if (this.isMultiple && !Array.isArray(this.document[this.fieldName])) {
        this.defaultValue = this.document[this.fieldName].split(',');
      }

      this.fieldValue = this.defaultValue;
    }
  }

  ngAfterViewInit() {
    if (this.isMultiple && this.deviceDetectService.detectMobile()) {
      let oldItems = this.fieldValue;
      if (!Array.isArray(oldItems)) {
        if (this.fieldValue) {
          oldItems = oldItems.split(',');
        }
      }
      setTimeout(() => {
        const dropDownItems = document.querySelectorAll('.dropdown-content a');
        dropDownItems.forEach((a, b) => {
          if (this.checkSelectedArray(oldItems, a.textContent.trim())) {
            a.classList.add('selected');
          }
        });
      });

    }
  }

  onFieldValueChanged(fieldValue) {
    if (this.fieldValue === fieldValue) {
      return;
    }

    if (fieldValue && this.isMultiple && !Array.isArray(fieldValue)) {

      if (this.fieldValue.join(',') === fieldValue) {
        return;
      }

      fieldValue = fieldValue.split(',');
    }

    this.fieldValue = fieldValue;
    this.formControl.patchValue(this.fieldValue, {emitEvent: false, onlySelf: true});
    this.formValueControl.patchValue(this.fieldValue, {emitEvent: false, onlySelf: true});

    this.updateSelectedOption(fieldValue);

    this.detectChanges();
  }

  updateSelectedOption(fieldValue) {
    const fieldValues = fieldValue ? fieldValue : [];
    const selected = document.querySelectorAll(`div#${this.registeredControlName} a`);
    selected.forEach((element) => {
      if (fieldValues.includes(element.textContent)) {
        element.classList.add('selected');
      } else {
        element.classList.remove('selected');
      }
    });
  }

  onClickEventDropDown($event) {
    if ($event.target.classList.contains('selected')) {
      $event.target.classList.remove('selected');
    } else {
      $event.target.classList.add('selected');
    }
    const selectedStrArray = [];
    const selected = document.querySelectorAll('.drop-down-class a.selected');
    selected.forEach((a, b) => {
      selectedStrArray.push(a.textContent);
    });

    this.fieldValue = JSON.parse(JSON.stringify(selectedStrArray));
    this.changedDocumentService.valueChanged(this, JSON.parse(JSON.stringify(selectedStrArray)), this.registeredControlName);
    this.formValueControl.patchValue(this.fieldValue, {emitEvent: false, onlySelf: true});
  }

  checkSelectedArray(strObject, needle) {
    let result = false;
    for (const valObj in strObject) {
      if (strObject[valObj] === needle) {
        result = true;
        break;
      }
    }
    return result;
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
